export default "__VITE_ASSET__BeA1vmFN__"